module.exports = __webpack_public_path__ + "static/img/icon-shop-manage-asset-center.dcc6dd91.png";